import { render, staticRenderFns } from "./EditDeleteActions.vue?vue&type=template&id=5f35763d&"
import script from "./EditDeleteActions.vue?vue&type=script&lang=js&"
export * from "./EditDeleteActions.vue?vue&type=script&lang=js&"
import style0 from "./EditDeleteActions.vue?vue&type=style&index=0&id=5f35763d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports